import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-form",
  "use": "google-form-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-form\"><g clip-path=\"url(#google-form_clip0_2_60)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#7530B8\" /><path d=\"M4.5 3.5H3V5h1.5V3.5zm8.5 0H6V5h7V3.5zM6 7.25h7v1.5H6v-1.5zm-1.5 0H3v1.5h1.5v-1.5zM6 11h7v1.5H6V11zm-1.5 0H3v1.5h1.5V11z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-form_clip0_2_60\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol